export const ARIA_LABEL_ID = 'rename-session';
export const INSTRUCTIONS =
	"Label reports requiring documentation in accordance with the organization's accessibility standards.";
export const EDIT_SESSION_POPUP_SHOW_INFO_MESSAGE = 'edit-session-popup-show-info-message';
export const DISMISS_MESSAGE = 'Changes you make will be saved on the Platform only';
